import React from 'react';
import { OutlineButton } from '../atoms/buttons/OutlineButton';
import { Row } from '../atoms/StructuralLayout';

export default function DoThisLaterButtonRow(props: {dataTest: string, disabled?: boolean, onClick: () => any}) {
  return (
    <Row className="onboarding__controlRow">
      <OutlineButton dataTest={props.dataTest}
                     disabled={!!props.disabled}
                     hideBorder={true}
                     className="teamMemberControls__later"
                     click={() => props.onClick()}
                     text="I'll do this later" />
    </Row>
  )
}
